import { Lock, Star } from '@mui/icons-material';
import { Avatar, Badge, Box, Divider, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { Award, AwardEarned } from './Types/Types';

interface Props {
    awards: Award[],
    earned: AwardEarned[],
    onClick?: (e : React.MouseEvent, award : Award) => any,
}

class AwardList extends Component<Props, {}> {
    render() {
        const { awards, earned, onClick } = this.props;

        const getAvatar = (award : Award) => {
            return process.env.PUBLIC_URL + '/awards/' + award.image;
        }

        const getName = (award : Award) => {
            if (award.is_secret) {
                return award.name.split('').map((char, index) => {
                    return '?';
                }).join('');
            }
            return award.name;
        }

        const getDescription = (award : Award) => {
            if (award.is_secret) {
                return award.name.split('').map((char, index) => {
                    return '?';
                }).join('');
            }
            return award.description;
        }

        const isEarned = (award : Award) => {
            return earned.find(e => e.award_id === award.id);
        }

        return (
            <React.Fragment>
                {(awards.length > 0)
                    ? <Virtuoso data={awards} itemContent={(index : number, award : Award) => {
                        return <React.Fragment>
                            <ListItemButton key={"user-item-" + index} onClick={onClick ? ((e) => onClick(e, award)) : undefined}>
                                <ListItemAvatar>
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                        badgeContent={
                                            isEarned(award)
                                                ? <Star sx={{ color: 'yellow' }}/>
                                                : <Lock sx={{ color: 'grey' }}/>
                                        }
                                    >
                                        <Avatar src={getAvatar(award)} sx={{ opacity: isEarned(award) ? 1 : 0.3, filter: isEarned(award) ? undefined : 'blur(3px)' }}/>
                                    </Badge>
                                </ListItemAvatar>
                                <Box sx={{ display: 'flex', width: '100%', opacity: isEarned(award) ? 1 : 0.3 }}>
                                    <Box flexGrow={1}>
                                        <ListItemText
                                            primary={getName(award)}
                                            secondary={getDescription(award)}
                                        />
                                    </Box>
                                </Box>
                            </ListItemButton>
                            {index < (awards.length - 1) && <Divider variant="inset" />}
                        </React.Fragment>;
                    }
                    }/>
                    :<Box sx={{ display: 'grid', placeItems: 'center', height: '100%', textAlign: 'center' }}>
                        <Box>
                            <Box><Typography variant={"h6"}>No koa Ehrung gfundn!</Typography></Box>
                            <Box><Typography variant={"body1"}>Des wa amend wos geils!</Typography></Box>
                        </Box>
                    </Box>}
            </React.Fragment>
        );
    }
}
export default AwardList;